var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("trigger"),_c('span',{ref:"tooltip"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('div',{ref:"content"},[_vm._t("default")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }